<template>
  <span v-resize="checkMobile" data-testid="bookings-list-page">
    <!-- <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading> -->
    <!-- Должникам -->
    <!-- <v-overlay absolute :value="$store.getters.getMainCompany &&
      $store.getters.getMainCompany.payer_state == 3
      ">
      <v-flex md12>
        {{ $t("other.message_no_pay") }}
        <v-btn color="success" :to="{ path: `/transactions` }">
          {{ $t("other.add_balance") }} ->
        </v-btn>
      </v-flex>
    </v-overlay> -->
    <!-- Брони -->
    <!-- <h2 v-if="!isMobile">{{ $t("archive.new_bookings") }}</h2> -->
    <!-- FT-082: unified command bar (shared with the board) -->
    <bookings-command-bar
      view="list"
      :scope="showActive ? 'active' : 'inactive'"
      :filters="filters"
      :cars="cars"
      :responsibles="responsibles"
      :cars-loading="carsLoading"
      :responsibles-loading="responsiblesLoading"
      :states="bookings_states"
      :connected="connected"
      :show-sort="false"
      :xlsx-loading="isLoadingDownloadXlsx"
      :ical-loading="isLoadingDownloadIcalendar"
      :selected-count="selectedBookings ? selectedBookings.length : 0"
      @set-scope="setScope"
      @input="onFilters"
      @reset="onReset"
      @load-cars="loadCarsOnce"
      @load-responsibles="loadResponsiblesOnce"
      @refresh="getDataFromApi"
      @export-xlsx="toXlsx"
      @export-ical="downloadIcalendar"
      @archive-selected="archiveBookings"
    />
    <v-row>
      <v-col cols="12" v-if="isLoading">
        <v-skeleton-loader type="table-tbody" v-if="isLoading"></v-skeleton-loader>
        <v-skeleton-loader type="table-tbody" v-if="isLoading && !isMobile"></v-skeleton-loader>
      </v-col>
      <v-col cols="12" v-else>
        <div class="list-table-wrap">
        <v-skeleton-loader v-if="mainTableLoading" class="list-table-skeleton" :style="skeletonStyle"
          :type="skeletonType(showBooking().length)" />
        <v-data-table v-if="inactive_bookings.length > 0 || showActive" v-model="selected" :headers="selectedHeaders"
          v-resize="checkMobile" :items="showBooking()" :loading="false" :loading-text="$t('custom.loading_table')"
          :search="search" :server-items-length.sync="total" :options.sync="tableOptions" :page.sync="page"
          item-key="id" :class="!isMobile ? 'mt-2 start-tour-bookings-1' : 'mt-2 start-tour-bookings-1 is-mobile'"
          mobile-breakpoint="100" :items-per-page="50" dense :footer-props="tableFooterProps([50, 150, 300, -1], `{0}-{1} ${$t('custom.of')} {2}`)">
          <template slot="header" slot-scope="props">
            <tr id="registration-step-64">
              <th v-for="header in props.headers" :key="header.text" nowrap>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="item" slot-scope="props">
            <tr @dblclick="replaceToBooking(props.item)" style="cursor: pointer"
              :class="selectColorBooking(props.item)">
              <td v-if="!showActive">
                <v-checkbox v-model="props.item.selected" color="primary"></v-checkbox>
              </td>
              <td class="text-center" :key="props.item.id">
                <v-chip v-if="props.item.vseprokaty_id || props.item.source == 'Localrent'" class="ma-2"
                  :color="props.item.active ? 'warning' : 'secondary'" text-color="white">
                  <v-avatar left color="secondary darken-2" v-tooltip="{
                    content: $t('agregator.from_agregator'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    <v-icon>mdi-alpha-a-circle-outline</v-icon>
                  </v-avatar>
                  <v-avatar left color="error darken-2" v-if="props.item.fast_booking" v-tooltip="{
                    content: $t('agregator.fast_booking'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    <v-icon>mdi-lightning-bolt-circle</v-icon>
                  </v-avatar>
                  <router-link class="white--text text-decoration-none" v-tooltip="{
                    content: `${$t('custom.number') + ' ' + props.item.number}`,
                    placement: 'bottom-center',
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" :to="{ name: 'BookingCard', params: { id: props.item.id } }">{{ props.item.id }}</router-link>
                </v-chip>
                <v-chip v-else-if="props.item.new" class="ma-2" color="info" text-color="white">
                  <v-avatar left>
                    <v-icon>mdi-new-box</v-icon>
                  </v-avatar>
                  <router-link class="white--text text-decoration-none"
                    :to="{ name: 'BookingCard', params: { id: props.item.id } }" v-tooltip="{
                      content: `${$t('custom.number') + ' ' + props.item.number}`,
                      placement: 'bottom-center',
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">{{ props.item.id }}</router-link>
                </v-chip>
                <v-flex v-else class="d-inline-flex">
                  <router-link id="booking_item" v-tooltip="{
                    content: `${$t('custom.number') + ' ' + props.item.number}`,
                    placement: 'bottom-center',
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" :to="{ name: 'BookingCard', params: { id: props.item.id } }">{{ props.item.id }}</router-link>
                </v-flex>
              </td>
              <td class="text-center">
                {{ formatCreatedAt(props.item.created_at) }}
              </td>
              <td class="text-center" v-if="showActive">
                <v-flex class="d-flex text-center justify-center">
                  <v-icon class="mr-2" v-if="props.item.in_rent" color="primary" v-tooltip="{
                    content: $t('bookings.in_rent'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    mdi-car
                  </v-icon>
                  <v-icon v-if="props.item.active && !props.item.in_rent" class="mr-2" style="z-index: 1"
                    color="secondary" v-tooltip="{
                      content: $t('bookings.booked'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                    mdi-clock-outline
                  </v-icon>
                  <v-icon v-if="props.item.failure" v-tooltip="{
                    content: $t('bookings.decline'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    mdi-close-circle-outline
                  </v-icon>
                </v-flex>
              </td>
              <td class="text-center">
                <booking-state-menu :state="props.item.state" :states="bookings_states"
                  :loading="isLoadingSaveBookingState && updatingBookingId == props.item.id"
                  @changed="saveBookingState($event, props.item.id)" />
              </td>
              <!-- Оплата -->
              <td class="text-center">
                <!-- <v-btn x-small outlined color="primary" v-if="!props.item.in_rent && props.item.counts.length === 0" @click="paymentStart(props.item)" :disabled="!props.item.active || props.item.in_rent" >Оплатить</v-btn>
                        <v-btn x-small :color="calculatePayments(props.item) != 'Оплачено' ? 'warning' : 'success'" v-if="props.item.counts.length > 0 || props.item.in_rent" @click="paymentStart(props.item)" :disabled="!props.item.active && (calculatePayments(props.item) != 'Оплачено' ? false : true)">{{calculatePayments(props.item)}}</v-btn> -->
                <v-btn x-small outlined :to="{ name: 'BookingCard', params: { id: props.item.id } }" color="primary"
                  v-if="
                    !props.item.in_rent &&
                    !props.item.ride &&
                    props.item.counts.length === 0 &&
                    !props.item.technical
                  " style="cursor: default" :disabled="!props.item.active || props.item.in_rent" v-tooltip="{
                  content: $t('bookings.not_paid'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">{{ $t("bookings.not_paid_2") }}</v-btn>
                <v-btn x-small :color="selectColorPaid(props.item)" v-if="showsPaymentChip(props.item)" style="cursor: default" :disabled="!props.item.active &&
                  (calculatePayments(props.item) != $t('bookings.paid')
                    ? false
                    : true)
                  " v-tooltip="{
                    content: `${calculatePayments(props.item) != $t('bookings.paid')
                      ? $t('bookings.partly_paid')
                      : $t('bookings.fully_paid')
                      }`,
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">{{ paymentChipLabel(props.item) }}</v-btn>
              </td>
              <td v-if="!isMobile" class="text-center">
                <router-link :to="{ path: `/cars/${props.item.car_id}` }"
                  :class="setCarStateClass(props.item.car_state)" v-tooltip="{
                    content: `${setCarStateTooltip(props.item.car_state)}`,
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">{{ props.item.car_name }}({{ props.item.car_code }})</router-link>
              </td>
              <td v-else nowrap class="text-center">
                <router-link :to="{ path: `/cars/${props.item.car_id}` }"
                  :class="setCarStateClass(props.item.car_state)">{{
                    props.item.car_name }}({{ props.item.car_code }})</router-link>
              </td>
              <td class="text-center" nowrap v-if="!props.item.entity">
                <router-link v-if="isStaff"
                  :class="checkClientCategory(props.item)"
                  :to="{ name: 'ClientCard', params: { id: props.item.client_id } }" v-tooltip="{
                    content: `${props.item.client_category}`,
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                  {{ props.item.last_name ? props.item.last_name : "" }}
                  {{ props.item.first_name ? `${props.item.first_name[0]}.` : "" }}
                  {{ props.item.middle_name ? `${props.item.middle_name[0]}.` : "" }}
                </router-link>
              </td>
              <td class="text-center" v-else>
                <router-link v-if="isStaff"
                  :class="checkClientCategory(props.item)"
                  :to="{ name: 'ClientCard', params: { id: props.item.client_id } }">{{ props.item.entity_name
                  }}</router-link>
              </td>
              <td v-if="!isMobile" nowrap class="text-center">
                {{ formatDateBookingDates(props.item.start_date) }}
                <br />
                {{ formatTimeBookingDates(props.item.start_date) }}
              </td>
              <td v-else nowrap class="text-center">
                {{ shortFormatBookingDates(props.item.start_date) }}
              </td>
              <td class="text-center" nowrap v-if="!isMobile && !props.item.active">
                {{ formatDateBookingDates(props.item.end_date) }}
                <br />
                {{ formatTimeBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center" nowrap v-if="isMobile && !props.item.active">
                {{ shortFormatBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center" nowrap v-if="!isMobile && props.item.active"
                :style="checkLateDate(props.item.end_date)">
                {{ formatDateBookingDates(props.item.end_date) }}
                <br />
                {{ formatTimeBookingDates(props.item.end_date) }}
                <v-icon v-if="props.item.payments_type == 'periodic'" class="mb-1" color="warning" size="16" v-tooltip="{
                  content: $t('bookings.payments_type_periodic'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: { show: 500, hide: 500 },
                }">
                  mdi-autorenew
                </v-icon>
              </td>
              <td class="text-center" nowrap v-if="isMobile && props.item.active"
                :style="checkLateDate(props.item.end_date)">
                {{ shortFormatBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center">{{ props.item.days }}</td>
              <td class="text-center">{{ props.item.location_start }}</td>
              <td class="text-center">{{ props.item.location_end }}</td>
              <td class="text-truncate" style="max-width: 200px" @click="
                (showDescriptionEditId = props.item.id),
                (descriptionEdit = props.item.description),
                (showDescriptionEditDialog = true)
                " v-tooltip="{
                  content: `${props.item.description}`,
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">
                {{ props.item.description }}
              </td>
              <!-- <td
                class="text-center description-trunc"
                @click="
                  (showDescriptionEditId = props.item.id),
                    (descriptionEdit = props.item.description),
                    (showDescriptionEditDialog = true)
                "
              >
                <read-more
                  v-if="props.item.description && props.item.description.length > 0"
                  :more-str="$t('custom.read')"
                  :text="props.item.description"
                  link="#"
                  :less-str="$t('custom.less')"
                  :max-chars="30"
                ></read-more>
              </td> -->
              <td class="text-center">
                <!-- Гейт на ВСЁ меню, а не на текст имени: кнопки-активаторы
                     ниже открывают тот же список сотрудников и ведут в
                     updateResponsible, который закрыт isStaff. Раньше условие
                     стояло на v-flex с именем — пропадало отображение, а
                     действие оставалось доступным. -->
                <v-flex class="px-3" v-if="isStaff">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-btn icon v-if="!props.item.responsible" @click="
                          getWorkersNames(),
                          (updatingBookingId = props.item.id)
                          "
                          :loading="(isLoadingGetWorkersNames || isLoadingUpdateResponsible) && updatingBookingId == props.item.id">
                          <v-icon color="secondary" class="mx-1" v-tooltip="{
                            content: $t('bookings.responsible'),
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            delay: {
                              show: 500,
                              hide: 500,
                            },
                          }">
                            mdi-account-question
                          </v-icon>
                        </v-btn>
                        <div v-else class="mx-1">
                          <v-btn icon @click="getWorkersNames(), (updatingBookingId = props.item.id)"
                            :loading="isLoadingUpdateResponsible && updatingBookingId == props.item.id">
                            <v-icon color="success" class="mr-1" v-tooltip="{
                              content: $t('bookings.responsible'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                              mdi-account-check
                            </v-icon>
                          </v-btn>
                          <v-flex @click="
                            getWorkersNames(),
                            (updatingBookingId = props.item.id)
                            " v-tooltip="{
                              content: $t('bookings.responsible'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                            {{ props.item.responsible }}
                          </v-flex>
                        </div>
                      </span>
                    </template>
                    <v-list class="mr-3">
                      <v-list-item v-for="(responsible, index) in responsibles" :key="index"
                        @click="updateResponsible(props.item.id, responsible.name, responsible.id)">
                        <v-list-item-title>
                          {{ responsible.name ? responsible.name : $t("bookings.no_responsible") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-flex>
              </td>
              <!-- <td
                class="text-center"
                v-if="props.item.responsible"
                @click="
                  getWorkersNames(),
                    (updatingBookingId = props.item.id),
                    (selected_worker = props.item.responsible),
                    (showSetResponsible = true)
                "
              >
                {{ props.item.responsible }}
              </td>
              <td class="text-center justify-center" v-else>
                <v-icon
                  class="mr-2"
                  color="grey"
                  @click="
                    getWorkersNames(),
                      (updatingBookingId = props.item.id),
                      (showSetResponsible = true)
                  "
                  v-tooltip="{
                    content: $t('bookings.responsible'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }"
                >
                  mdi-account-question
                </v-icon>
              </td> -->
            </tr>
          </template>
          <template slot="no-data">
            {{ $t("custom.no_data_in_table") }}
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
            {{ $t("tables.no_search_result", { msg: search }) }}
          </v-alert>
        </v-data-table>
        </div>
        <!-- Отъезженные брони -->
        <v-divider v-if="!showActive && inactive_bookings.length > 0"></v-divider>
        <h2 v-if="!showActive && rided_bookings.length > 0">
          {{ $t("archive.ride_bookings") }}
        </h2>
        <v-toolbar v-if="
          !showActive &&
          rided_bookings.length > 0 &&
          inactive_bookings.length > 0
        " text :color="$vuetify.theme.dark ? '' : 'white'">
          <v-spacer></v-spacer>
          <v-row align="center" class="ml-2">
            <!-- FT-082: rided table is server-paginated; use the toolbar search above. -->
            <v-icon v-if="selectedBookings && selectedBookings.length > 0" @click="archiveBookings()" color="red"
              class="mx-2" size="30" v-tooltip="{
                content: $t('bookings.archivate_booking'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }">
              mdi-archive-arrow-down
            </v-icon>
          </v-row>
        </v-toolbar>
        <div class="list-table-wrap">
        <v-skeleton-loader v-if="ridedLoading" class="list-table-skeleton" :style="skeletonStyle"
          :type="skeletonType(rided_bookings.length)" />
        <v-data-table v-if="!showActive && rided_bookings.length > 0" :headers="selectedHeaders" v-resize="checkMobile"
          :items="rided_bookings" :loading="false" :loading-text="$t('custom.loading_table')"
          :server-items-length="ridedTotal" :options.sync="ridedOptions"
          :disable-sort="sort_date && !(sort_date == '' || sort_date == null) ? true : false
            " item-key="id"
          :class="!isMobile ? 'mt-2' : 'mt-2 is-mobile'" mobile-breakpoint="100" :items-per-page="50" dense
          :footer-props="tableFooterProps([50, 150, 300, -1], `{0}-{1} ${$t('custom.of')} {2}`)">
          <template slot="header" slot-scope="props">
            <tr id="registration-step-64">
              <th v-for="header in props.headers" :key="header.text" nowrap>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="item" slot-scope="props">
            <tr @dblclick="replaceToBooking(props.item)" style="cursor: pointer"
              :class="!props.item.technical ? '' : 'blue-grey lighten-4'">
              <td v-if="!showActive">
                <v-checkbox v-model="props.item.selected" color="primary"></v-checkbox>
              </td>
              <td class="text-center" :key="props.item.id">
                <v-chip v-if="props.item.vseprokaty_id" class="ma-2"
                  :color="props.item.active ? 'warning' : 'secondary'" text-color="white">
                  <v-avatar left color="secondary darken-2" v-tooltip="{
                    content: $t('agregator.from_agregator'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    <v-icon>mdi-alpha-a-circle-outline</v-icon>
                  </v-avatar>
                  <v-avatar left v-if="props.item.fast_booking" color="error darken-2" v-tooltip="{
                    content: $t('agregator.fast_booking'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    <v-icon>mdi-lightning-bolt-circle</v-icon>
                  </v-avatar>
                  <router-link class="white--text text-decoration-none"
                    :to="{ name: 'BookingCard', params: { id: props.item.id } }">{{ props.item.id }}</router-link>
                </v-chip>
                <v-chip v-else-if="props.item.new" class="ma-2" color="info" text-color="white">
                  <v-avatar left>
                    <v-icon>mdi-new-box</v-icon>
                  </v-avatar>
                  <router-link :to="{ name: 'BookingCard', params: { id: props.item.id } }">{{ props.item.id
                  }}</router-link>
                </v-chip>
                <v-flex v-else class="d-inline-flex">
                  <router-link :to="{ name: 'BookingCard', params: { id: props.item.id } }">{{ props.item.id
                  }}</router-link>
                </v-flex>
              </td>
              <td class="text-center">
                {{ formatCreatedAt(props.item.created_at) }}
              </td>
              <td class="text-center" v-if="showActive">
                <v-flex class="d-flex text-center justify-center">
                  <v-icon class="mr-2" v-if="props.item.in_rent" color="primary" v-tooltip="{
                    content: $t('bookings.in_rent'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    mdi-car
                  </v-icon>
                  <v-icon v-if="props.item.active && !props.item.in_rent" class="mr-2" style="z-index: 1"
                    color="secondary" v-tooltip="{
                      content: $t('bookings.booked'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                    mdi-clock-outline
                  </v-icon>
                  <v-icon v-if="props.item.failure" v-tooltip="{
                    content: $t('bookings.decline'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    mdi-close-circle-outline
                  </v-icon>
                </v-flex>
              </td>
              <td class="text-center">
                <v-flex class="d-flex text-center justify-center">
                  <booking-state-menu plain :state="props.item.state" :states="bookings_states"
                    @changed="saveBookingState($event, props.item.id)" />
                </v-flex>
              </td>
              <!-- Оплата -->
              <td class="text-center">
                <!-- <v-btn x-small outlined color="primary" v-if="!props.item.in_rent && props.item.counts.length === 0" @click="paymentStart(props.item)" :disabled="!props.item.active || props.item.in_rent" >Оплатить</v-btn>
                        <v-btn x-small :color="calculatePayments(props.item) != 'Оплачено' ? 'warning' : 'success'" v-if="props.item.counts.length > 0 || props.item.in_rent" @click="paymentStart(props.item)" :disabled="!props.item.active && (calculatePayments(props.item) != 'Оплачено' ? false : true)">{{calculatePayments(props.item)}}</v-btn> -->
                <v-btn x-small outlined :to="{ name: 'BookingCard', params: { id: props.item.id } }" color="primary"
                  v-if="
                    !props.item.in_rent &&
                    !props.item.ride &&
                    props.item.counts.length === 0 &&
                    !props.item.technical
                  " style="cursor: default" :disabled="!props.item.active || props.item.in_rent" v-tooltip="{
                  content: $t('bookings.not_paid'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">{{ $t("bookings.not_paid_2") }}</v-btn>
                <v-btn x-small :color="selectColorPaid(props.item)" v-if="showsPaymentChip(props.item)" style="cursor: default" :disabled="!props.item.active &&
                  (calculatePayments(props.item) != $t('bookings.paid')
                    ? false
                    : true)
                  " v-tooltip="{
                    content: `${calculatePayments(props.item) != $t('bookings.paid')
                      ? $t('bookings.partly_paid')
                      : $t('bookings.fully_paid')
                      }`,
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">{{ paymentChipLabel(props.item) }}</v-btn>
              </td>
              <td v-if="!isMobile" class="text-center">
                <router-link :to="{ path: `/cars/${props.item.car_id}` }"
                  :class="setCarStateClass(props.item.car_state)" v-tooltip="{
                    content: `${setCarStateTooltip(props.item.car_state)}`,
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">{{ props.item.car_name }}({{ props.item.car_code }})</router-link>
              </td>
              <td v-else nowrap class="text-center">
                <router-link :to="{ path: `/cars/${props.item.car_id}` }"
                  :class="setCarStateClass(props.item.car_state)">{{
                    props.item.car_code }}</router-link>
              </td>
              <td class="text-center" nowrap v-if="!props.item.entity">
                <router-link v-if="isStaff"
                  :class="checkClientCategory(props.item)"
                  :to="{ name: 'ClientCard', params: { id: props.item.client_id } }" v-tooltip="{
                    content: `${props.item.client_category}`,
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                  {{ props.item.last_name ? props.item.last_name : "" }}
                  {{ props.item.first_name ? props.item.first_name[0] : "" }}.
                  {{ props.item.middle_name ? props.item.middle_name[0] : "" }}.
                </router-link>
              </td>
              <td class="text-center" v-else>
                <router-link v-if="isStaff"
                  :class="checkClientCategory(props.item)"
                  :to="{ name: 'ClientCard', params: { id: props.item.client_id } }">{{ props.item.entity_name
                  }}</router-link>
              </td>
              <td v-if="!isMobile" nowrap class="text-center">
                {{ formatDateBookingDates(props.item.start_date) }}
                <br />
                {{ formatTimeBookingDates(props.item.start_date) }}
              </td>
              <td v-else nowrap class="text-center">
                {{ shortFormatBookingDates(props.item.start_date) }}
              </td>
              <td class="text-center" nowrap v-if="!isMobile && !props.item.active">
                {{ formatDateBookingDates(props.item.end_date) }}
                <br />
                {{ formatTimeBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center" nowrap v-if="isMobile && !props.item.active">
                {{ shortFormatBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center" nowrap v-if="!isMobile && props.item.active"
                :style="checkLateDate(props.item.end_date)">
                {{ formatDateBookingDates(props.item.end_date) }}
                <br />
                {{ formatTimeBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center" nowrap v-if="isMobile && props.item.active"
                :style="checkLateDate(props.item.end_date)">
                {{ shortFormatBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center">{{ props.item.days }}</td>
              <td class="text-center">{{ props.item.location_start }}</td>
              <td class="text-center">{{ props.item.location_end }}</td>
              <td class="text-truncate" style="max-width: 200px" @click="
                (showDescriptionEditId = props.item.id),
                (descriptionEdit = props.item.description),
                (showDescriptionEditDialog = true)
                " v-tooltip="{
                  content: `${props.item.description}`,
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">
                {{ props.item.description }}
              </td>
              <!-- <td
                class="text-center description-trunc"
                @click="
                  (showDescriptionEditId = props.item.id),
                    (descriptionEdit = props.item.description),
                    (showDescriptionEditDialog = true)
                "
              >
                <read-more
                  v-if="props.item.description && props.item.description.length > 0"
                  :more-str="$t('custom.read')"
                  :text="props.item.description"
                  link="#"
                  :less-str="$t('custom.less')"
                  :max-chars="30"
                ></read-more>
              </td> -->
              <td class="text-center" v-if="props.item.responsible" @click="
                getWorkersNames(),
                (updatingBookingId = props.item.id),
                (selected_worker = props.item.responsible),
                (showSetResponsible = true)
                ">
                {{ props.item.responsible }}
              </td>
              <td class="text-center justify-center" v-else>
                <v-icon class="mr-2" color="grey" @click="
                  getWorkersNames(),
                  (updatingBookingId = props.item.id),
                  (showSetResponsible = true)
                  " v-tooltip="{
                    content: $t('bookings.responsible'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                  mdi-account-question
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
        </div>
        <!-- Частичные возвраты залога -->
        <v-divider v-if="
          !showActive &&
          part_return_deposit_bookings &&
          part_return_deposit_bookings.length > 0
        "></v-divider>
        <h2 v-if="
          !showActive &&
          part_return_deposit_bookings &&
          part_return_deposit_bookings.length > 0
        ">
          {{ $t("bookings.return_deposits") }}
        </h2>
        <v-toolbar v-if="
          !showActive &&
          part_return_deposit_bookings &&
          part_return_deposit_bookings.length > 0
        " text :color="$vuetify.theme.dark ? '' : 'white'">
          <v-spacer></v-spacer>
          <v-row align="center" class="ml-2">
            <v-text-field :dense="isMobile" v-model="search_return_deposit" prepend-icon="mdi-magnify"
              :label="$t('custom.search')" single-line clearable hide-details></v-text-field>
            <v-spacer></v-spacer>
            <download-excel :data="part_return_deposit_bookings" v-if="
              part_return_deposit_bookings &&
              part_return_deposit_bookings.length > 0 &&
              isStaff
            ">
              <v-icon class="ml-2" style="cursor: pointer" color="success">
                mdi-file-excel-outline
              </v-icon>
            </download-excel>
          </v-row>
        </v-toolbar>
        <div class="list-table-wrap">
        <v-skeleton-loader v-if="depositLoading" class="list-table-skeleton" :style="skeletonStyle"
          :type="skeletonType(part_return_deposit_bookings.length)" />
        <v-data-table v-if="
          !showActive &&
          part_return_deposit_bookings &&
          part_return_deposit_bookings.length > 0
        " v-model="selected" :headers="headers_return_deposit" v-resize="checkMobile"
          :items="part_return_deposit_bookings" :loading="false" :loading-text="$t('custom.loading_table')"
          :server-items-length="depositTotal" :options.sync="depositOptions"
          :disable-sort="sort_date && !(sort_date == '' || sort_date == null) ? true : false
            " item-key="id"
          :class="!isMobile ? 'mt-2' : 'mt-2 is-mobile'" mobile-breakpoint="100" :items-per-page="50" dense
          :footer-props="tableFooterProps([20, 50, 100, -1], `{0}-{1} ${$t('custom.of')} {2}`)">
          <template slot="header" slot-scope="props">
            <tr>
              <th v-for="header in props.headers" :key="header.text" nowrap>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="item" slot-scope="props">
            <tr @dblclick="replaceToBooking(props.item)" style="cursor: pointer"
              :class="selectColorRidedBooking(props.item)">
              <td class="text-center" :key="props.item.id">
                <v-chip v-if="props.item.new" class="ma-2" color="info" text-color="white">
                  <v-avatar left>
                    <v-icon>mdi-new-box</v-icon>
                  </v-avatar>
                  <router-link :to="{ name: 'BookingCard', params: { id: props.item.id } }">{{ props.item.id
                  }}</router-link>
                </v-chip>
                <v-flex v-else class="d-inline-flex">
                  <router-link :to="{ name: 'BookingCard', params: { id: props.item.id } }">{{ props.item.id
                  }}</router-link>
                </v-flex>
              </td>
              <td v-if="!isMobile" class="text-center">
                {{ formatCreatedAt(props.item.created_at) }}
              </td>
              <!-- Оплата -->
              <td class="text-center">
                <!-- <v-btn x-small outlined color="primary" v-if="!props.item.in_rent && props.item.counts.length === 0" @click="paymentStart(props.item)" :disabled="!props.item.active || props.item.in_rent" >Оплатить</v-btn>
                        <v-btn x-small :color="calculatePayments(props.item) != 'Оплачено' ? 'warning' : 'success'" v-if="props.item.counts.length > 0 || props.item.in_rent" @click="paymentStart(props.item)" :disabled="!props.item.active && (calculatePayments(props.item) != 'Оплачено' ? false : true)">{{calculatePayments(props.item)}}</v-btn> -->
                <v-btn x-small outlined :to="{ name: 'BookingCard', params: { id: props.item.id } }" color="primary"
                  v-if="
                    !props.item.in_rent &&
                    !props.item.ride &&
                    props.item.counts.length === 0 &&
                    !props.item.technical
                  " style="cursor: default" :disabled="!props.item.active || props.item.in_rent" v-tooltip="{
                  content: $t('bookings.not_paid'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">{{ $t("bookings.not_paid") }}</v-btn>
                <v-btn x-small :color="selectColorPaid(props.item)" v-if="showsPaymentChip(props.item)" style="cursor: default" :disabled="!props.item.active &&
                    (calculatePayments(props.item) != $t('bookings.paid')
                      ? false
                      : true)
                    " v-tooltip="{
                      content: `${calculatePayments(props.item) != $t('bookings.paid')
                        ? $t('bookings.partly_paid')
                        : $t('bookings.fully_paid')
                        }`,
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">{{ paymentChipLabel(props.item) }}</v-btn>
              </td>
              <td class="text-center">
                {{ returnDepositSum(props.item) }}
              </td>
              <td v-if="!isMobile" class="text-center">
                <router-link :to="{ path: `/cars/${props.item.car_id}` }"
                  :class="setCarStateClass(props.item.car_state)" v-tooltip="{
                    content: `${setCarStateTooltip(props.item.car_state)}`,
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">{{ props.item.car_name }}({{ props.item.car_code }})</router-link>
              </td>
              <td v-else nowrap class="text-center">
                <router-link :to="{ path: `/cars/${props.item.car_id}` }"
                  :class="setCarStateClass(props.item.car_state)">{{
                    props.item.car_code }}</router-link>
              </td>
              <td class="text-center" nowrap v-if="!props.item.entity">
                <router-link v-if="isStaff"
                  :class="checkClientCategory(props.item)"
                  :to="{ name: 'ClientCard', params: { id: props.item.client_id } }" v-tooltip="{
                    content: `${props.item.client_category}`,
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                  {{ props.item.last_name ? props.item.last_name : "" }}
                  {{ props.item.first_name ? props.item.first_name[0] : "" }}.
                  {{ props.item.middle_name ? props.item.middle_name[0] : "" }}.
                </router-link>
              </td>
              <td class="text-center" v-else>
                <router-link v-if="isStaff"
                  :class="checkClientCategory(props.item)"
                  :to="{ name: 'ClientCard', params: { id: props.item.client_id } }">{{ props.item.entity_name
                  }}</router-link>
              </td>
              <td v-if="!isMobile" nowrap class="text-center">
                {{ formatDateBookingDates(props.item.start_date) }}
                <br />
                {{ formatTimeBookingDates(props.item.start_date) }}
              </td>
              <td v-else nowrap class="text-center">
                {{ shortFormatBookingDates(props.item.start_date) }}
              </td>
              <td class="text-center" nowrap v-if="!isMobile && !props.item.active">
                {{ formatDateBookingDates(props.item.end_date) }}
                <br />
                {{ formatTimeBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center" nowrap v-if="isMobile && !props.item.active">
                {{ shortFormatBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center" nowrap v-if="!isMobile && props.item.active"
                :style="checkLateDate(props.item.end_date)">
                {{ formatDateBookingDates(props.item.end_date) }}
                <br />
                {{ formatTimeBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center" nowrap v-if="isMobile && props.item.active"
                :style="checkLateDate(props.item.end_date)">
                {{ shortFormatBookingDates(props.item.end_date) }}
              </td>
              <td class="text-center">{{ props.item.days }}</td>
              <td class="text-center">{{ props.item.location_start }}</td>
              <td class="text-center">{{ props.item.location_end }}</td>
              <td class="text-truncate" style="max-width: 200px" @click="
                (showDescriptionEditId = props.item.id),
                (descriptionEdit = props.item.description),
                (showDescriptionEditDialog = true)
                " v-tooltip="{
                  content: `${props.item.description}`,
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">
                {{ props.item.description }}
              </td>
              <!-- <td
                class="text-center description-trunc"
                @click="
                  (showDescriptionEditId = props.item.id),
                    (descriptionEdit = props.item.description),
                    (showDescriptionEditDialog = true)
                "
              >
                <read-more
                  v-if="props.item.description && props.item.description.length > 0"
                  :more-str="$t('custom.read')"
                  :text="props.item.description"
                  link="#"
                  :less-str="$t('custom.less')"
                  :max-chars="30"
                ></read-more>
              </td> -->
              <td class="text-center" v-if="props.item.responsible" @click="
                getWorkersNames(),
                (updatingBookingId = props.item.id),
                (selected_worker = props.item.responsible),
                (showSetResponsible = true)
                ">
                {{ props.item.responsible }}
              </td>
              <td class="text-center" v-else>
                <v-icon class="mr-2" color="grey" @click="
                  getWorkersNames(),
                  (updatingBookingId = props.item.id),
                  (showSetResponsible = true)
                  " v-tooltip="{
                    content: $t('bookings.responsible'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                  mdi-account-question
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="showSetResponsible" :retain-focus="false" @click:outside="
      (selected_worker = null),
      (updatingBookingId = null),
      (showSetResponsible = false)
      " persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            $t("bookings.selecting_responsible")
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select v-model="selected_worker" :items="workers_names" :label="$t('bookings.responsible_employee')"
                  item-text="name" item-value="name"></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="
            (selected_worker = null),
            (updatingBookingId = null),
            (showSetResponsible = false)
            ">
            {{ $t("custom.close") }}
          </v-btn>
          <v-btn color="success" text @click="saveResponsibale()">
            {{ $t("custom.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDescriptionEditDialog" :retain-focus="false" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("bookings.booking_description") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-textarea v-model="descriptionEdit" auto-grow rows="2"
                  :label="$t('bookings.add_info_booking')"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="
            (descriptionEdit = null),
            (showDescriptionEditId = null),
            (showDescriptionEditDialog = false)
            ">
            {{ $t("custom.close") }}
          </v-btn>
          <v-btn color="success" text @click="saveDescriptionEdit()">
            {{ $t("custom.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Badge } from "@capawesome/capacitor-badge";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import PullToRefresh from "pulltorefreshjs";
import CableSubscriber from "@/mixins/CableSubscriber";
import { getConsumer } from "@/cable";
import BookingStateMenu from "@/components/dashboard/bookings/list/BookingStateMenu.vue";
import bookingsExportMixin from "@/mixins/bookingsExportMixin";
import bookingsQueryState from "@/mixins/bookingsQueryState";
import BookingsCommandBar from "@/components/dashboard/bookings/BookingsCommandBar.vue";
// Статус оплаты (подпись с валютой + цвет) — общий хелпер с доской броней.
import { bookingPaymentChip, hasPaymentChip, legacyPaymentLabel } from "@/components/dashboard/bookings/paymentStatus";

export default {
  name: "BookingsListView",
  mixins: [CableSubscriber, bookingsExportMixin, bookingsQueryState],
  data() {
    return {
      subscribedCompanyId: null, // ID компании для отписки от канала
      bookings: [],
      active_bookings: [],
      inactive_bookings: [],
      rided_bookings: [],
      filtered_inactive_bookings: [],
      filtered_rided_bookings: [],
      part_return_deposit_bookings: [],
      workers_names: [],
      selected_worker: null,
      show_active_booking: true,
      updateIntervalFunc: null,
      payment: {
        cash: 0,
        cashless: 0,
        cash_card: 0,
        entity: 0,
        booking_id: null,
      },
      gas_start: 0,
      gas_end: 0,
      showArrivalPayments: false,
      showCashCardPayment: false,
      showCashPayment: false,
      showAddPayment: false,
      giveFullDeposit: true,
      showAddArrivalPayment: false,
      giveNullDeposit: false,
      showCleanPaid: false,
      fuel_price: 50,
      clean_price: 0,
      limitCost: 0,
      limitExept: false,
      departure_payments: {
        rent: { sum: 0, type: null },
        deposit: { sum: 0, type: null },
        delivery: { sum: 0, type: null },
        clean: { sum: 0, type: null },
        hours_cost: { sum: 0, type: null },
        insurance: { sum: 0, type: null },
        add_drivers_cost: { sum: 0, type: null },
        equipment: { sum: 0, type: null },
        other: { sum: 0, type: null },
      },
      arrival_payments: {
        rent: { sum: 0, type: null },
        clean: { sum: 0, type: null },
        delivery: { sum: 0, type: null },
        additional_hours: { sum: 0, type: null },
        mileage: { sum: 0, type: null },
        gas: { sum: 0, type: null },
        insurance: { sum: 0, type: null },
        add_drivers_cost: { sum: 0, type: null },
        equipment: { sum: 0, type: null },
        fine: { sum: 0, type: null },
        damage: { sum: 0, type: null },
        other: { sum: 0, type: null },
        deposit: { sum: 0, type: null },
      },
      prolongData: {
        days: null,
        price: null,
        additional_hours: null,
        sum: null,
        type: null,
        add_time_sum: null,
        add_time_type: null,
      },
      add_services: [
        { text: this.$t("add_services.clean"), value: "Мойка" },
        {
          text: this.$t("add_services.add_hours"),
          value: "Дополнительное время",
        },
        {
          text: this.$t("add_services.extra_mileage"),
          value: "Превышение пробега",
        },
        { text: this.$t("add_services.fuel"), value: "Топливо" },
        { text: this.$t("add_services.delivery"), value: "Доставка" },
        { text: this.$t("add_services.checkout"), value: "Приём" },
        { text: this.$t("add_services.rent"), value: "Аренда" },
        { text: this.$t("add_services.insurance"), value: "Страховка" },
        { text: this.$t("add_services.add_drivers"), value: "Доп водители" },
        { text: this.$t("add_services.equipment"), value: "Оборудование" },
        { text: this.$t("add_services.fines"), value: "Штрафы" },
        { text: this.$t("add_services.damages"), value: "Повреждения" },
        { text: this.$t("add_services.others"), value: "Другое" },
      ],
      selected_add_services: [],
      fines: [],
      fines_state: [
        { text: this.$t("fines_state.created"), value: "Создан" },
        { text: this.$t("fines_state.notify"), value: "Оповещён" },
        { text: this.$t("fines_state.paid"), value: "Оплачен" },
        { text: this.$t("fines_state.refund"), value: "Возмещён" },
      ],
      fines_headers_small: [
        { text: this.$t("fines.number"), align: "center", value: "number" },
        { text: this.$t("custom.date"), value: "date", align: "center" },
        { text: this.$t("custom.client"), value: "client_id", align: "center" },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.state"), value: "state", align: "center" },
      ],
      part_payment: false,
      showProblems: false,
      manualEditing: false,
      showDescription: false,
      showAddDrivers: false,
      selected: [],
      search: "",
      search_rided_bookings: null,
      search_add_driver: "",
      bookings_states: [
        { text: this.$t("bookings_states.new"), value: "Новая" },
        { text: this.$t("bookings_states.in_work"), value: "В обработке" },
        { text: this.$t("bookings_states.abandoned"), value: "Недозвон" },
        { text: this.$t("bookings_states.decline"), value: "Отказ клиента" },
        { text: this.$t("bookings_states.no_cars"), value: "Нет машин" },
        {
          text: this.$t("bookings_states.wait_answer"),
          value: "Ожидает ответа клиента",
        },
        { text: this.$t("bookings_states.wait_pay"), value: "Ожидает оплаты" },
        { text: this.$t("bookings_states.active"), value: "Активная" },
        { text: this.$t("bookings_states.cancel"), value: "Отмена" },
        { text: this.$t("bookings_states.rided"), value: "Отъездила" },
        {
          text: this.$t("bookings_states.return_deposit"),
          value: "Вернуть залог",
        },
        { text: this.$t("bookings_states.accepted"), value: "Подтверждена" },
        {
          text: this.$t("bookings_states.not_accepted"),
          value: "Не подтверждена",
        },
        { text: this.$t("bookings_states.other"), value: "Другое" },
      ],
      selected_booking_state: null,
      showDescriptionEditId: null,
      showDescriptionEditDialog: false,
      descriptionEdit: null,
      showSetBookingState: false,
      searchClient: "",
      rowsPerPageItems: [10, 25, 50, 100, -1],
      headers: [
        { text: "", sortable: false, align: "center" },
        { text: this.$t("custom.number"), value: "id", align: "center", sortable: false },
        {
          text: this.$t("custom.created"),
          value: "created_at",
          align: "center",
        },
        {
          text: this.$t("custom.state_short"),
          value: "in_rent",
          align: "center",
        },
        {
          text: this.$t("custom.state_short_2"),
          value: "state",
          align: "center",
        },
        {
          text: this.$t("bookings.payment"),
          align: "center",
          value: "counts",
          sort: (a, b) => {
            console.log("counts", a, b)
            return a.counts - b.counts;
          },
        },
        { text: this.$t("cars.name"), value: "car_code", align: "center" },
        { text: this.$t("custom.client"), value: "full_name", align: "center" },
        {
          text: this.$t("custom.start"),
          value: "start_date_formatted",
          align: "center",
          // sort: (a, b) => {
          //   return moment(a, "DD-MM-YYYY H:mm").diff(
          //     moment(b, "DD-MM-YYYY H:mm")
          //   );
          // },
        },
        {
          text: this.$t("custom.end"),
          value: "end_date_formatted",
          align: "center",
          // sort: (a, b) => {
          //   return moment(a, "DD-MM-YYYY H:mm").diff(
          //     moment(b, "DD-MM-YYYY H:mm")
          //   );
          // },
        },
        {
          text: this.$t("custom.days"),
          sortable: false,
          value: "days",
          align: "center",
        },
        {
          text: this.$t("custom.checkin"),
          sortable: false,
          value: "location_start",
          align: "center",
        },
        {
          text: this.$t("custom.checkout"),
          sortable: false,
          value: "location_end",
          align: "center",
        },
        {
          text: this.$t("custom.description_2"),
          sortable: false,
          align: "center",
        },
        { text: this.$t("custom.resp"), sortable: false, align: "center" },
      ],
      mobile_headers: [
        { text: "", sortable: false, align: "center" },
        { text: this.$t("custom.number"), value: "id", align: "center", sortable: false },
        // { text: this.$t('custom.created'), value: "created_at", align: "center" },
        {
          text: this.$t("custom.state_short"),
          value: "in_rent",
          align: "center",
        },
        {
          text: this.$t("custom.state_short_2"),
          value: "state",
          align: "center",
        },
        { text: this.$t("bookings.payment"), align: "center" },
        { text: this.$t("custom.car"), value: "car_code", align: "center" },
        { text: this.$t("custom.client"), value: "full_name", align: "center" },
        {
          text: this.$t("custom.start"),
          value: "start_date",
          align: "center",
          sort: (a, b) => {
            return moment(a, "DD-MM-YYYY H:mm").diff(
              moment(b, "DD-MM-YYYY H:mm")
            );
          },
        },
        {
          text: this.$t("custom.end"),
          value: "end_date",
          align: "center",
          sort: (a, b) => {
            return moment(a, "DD-MM-YYYY H:mm").diff(
              moment(b, "DD-MM-YYYY H:mm")
            );
          },
        },
        {
          text: this.$t("custom.days"),
          sortable: false,
          value: "days",
          align: "center",
        },
        {
          text: this.$t("custom.checkin"),
          sortable: false,
          value: "location_start",
          align: "center",
        },
        {
          text: this.$t("custom.checkout"),
          sortable: false,
          value: "location_end",
          align: "center",
        },
        {
          text: this.$t("custom.description_2"),
          sortable: false,
          align: "center",
        },
        { text: this.$t("custom.resp"), sortable: false, align: "center" },
      ],
      headers_return_deposit: [
        { text: this.$t("custom.number"), value: "id", align: "center", sortable: false },
        {
          text: this.$t("custom.created"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("bookings.payment"), align: "center" },
        { text: this.$t("bookings.payment_end"), align: "center" },
        { text: this.$t("custom.car"), value: "car_code", align: "center" },
        { text: this.$t("custom.client"), value: "full_name", align: "center" },
        {
          text: this.$t("custom.start"),
          value: "start_date",
          align: "center",
          sort: (a, b) => {
            return moment(a, "DD-MM-YYYY H:mm").diff(
              moment(b, "DD-MM-YYYY H:mm")
            );
          },
        },
        {
          text: this.$t("custom.end"),
          value: "end_date",
          align: "center",
          sort: (a, b) => {
            return moment(a, "DD-MM-YYYY H:mm").diff(
              moment(b, "DD-MM-YYYY H:mm")
            );
          },
        },
        {
          text: this.$t("custom.days"),
          sortable: false,
          value: "days",
          align: "center",
        },
        {
          text: this.$t("custom.checkout"),
          sortable: false,
          value: "location_start",
          align: "center",
        },
        {
          text: this.$t("custom.checkin"),
          sortable: false,
          value: "location_end",
          align: "center",
        },
        {
          text: this.$t("custom.description_2"),
          sortable: false,
          align: "center",
        },
        { text: this.$t("custom.resp"), sortable: false, align: "center" },
      ],
      sortingBookings: { sortBy: "created_at", descending: true },
      options: {
        sortBy: "car_code",
      },
      dialog: false,
      payment_dialog: false,
      showCashlessPayment: false,
      showEntityPayment: false,
      showPartRejection: false,
      prolong: false,
      departure: false,
      departure_yes: false,
      arrival_yes: false,
      editedBooking: { payments: [], counts: [] },
      selected_car: null,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      showClients: true,
      isLoadingClients: false,
      isLoadingClientsAddDriver: false,
      showEditClient: false,
      editPlace: false,
      editSale: false,
      connected: false,
      reloadPending: false,
      configSort: {
        altFormat: "d-m-Y",
        altInput: true,
        dateFormat: "d-m-Y",
        disableMobile: "true",
      },
      sort_date: null,
      sort_date_for_input: null,
      menu_sort_date: false,
      attrs_calendar: [
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "outline",
            contentClass: "italic",
          },
          dates: new Date(),
        },
      ],
      start_date: null,
      start_date_with_time: null,
      hours: 0,
      days: 0,
      editDate: false,
      start_time: null,
      end_date: null,
      end_date_with_time: null,
      end_time: null,
      datesWithTime: null,
      dates: null,
      set_car: null,
      extra: false,
      sale: false,
      editExtra: false,
      editCar: false,
      clients: [],
      customer_category: [
        { text: this.$t("customer_category.new"), value: "Новый" },
        { text: this.$t("customer_category.loyal"), value: "Лояльный" },
        { text: this.$t("customer_category.statement"), value: "Постоянный" },
        { text: this.$t("customer_category.problem"), value: "Серый" },
        { text: this.$t("customer_category.bad"), value: "Чёрный" },
      ],
      clients_arr: [],
      search_return_deposit: null,
      dont_send_review_reminder: false,
      warningAddOneDay: false,
      warningLessThenDay: false,
      doc_template_url: "",
      entity_doc_template_url: "",
      showSetResponsible: false,
      updatingBookingId: null,
      page: 1,
      per_page: 50,
      // FT-082: no default column sort -> backend default_order (active: in-rent then
      // newest; inactive buckets: newest first), matching the old page. "state" as the
      // default sorted alphabetically by the Cyrillic state name (meaningless order).
      sort_by: "",
      direction: "desc",
      tableOptions: {},
      total: 0,
      // FT-082: inactive view = three independently server-paginated tables
      // (rided / deposit-return / pure inactive). Each keeps its own total +
      // v-data-table options; the backend #list returns a `columns` map and a
      // `bucket` param loads a single table's page.
      ridedTotal: 0,
      depositTotal: 0,
      ridedOptions: {},
      depositOptions: {},
      ridedInitial: true,
      depositInitial: true,
      // per-table loading so paging one table skeletons only that table
      inactiveLoading: false,
      ridedLoading: false,
      depositLoading: false,
      // FT-082: shared filter surface with the board (BookingBoardToolbar). Sort is
      // omitted here — the list sorts via its data-table column headers.
      filters: {
        search: null,
        state: [],
        car_id: null,
        responsible: null,
        date_from: null,
        date_to: null,
        payment_status: null,
        overdue: false,
        deposit_return: false,
      },
      cars: [],
      responsibles: [],
      carsLoading: false,
      responsiblesLoading: false,
      realtimeTimeout: null,
      timeout: null,
      isMobile: false,
      isLoading: false,
      isLoadingDownloadIcalendar: false,
      isLoadingDownloadXlsx: false,
      isLoadingSaveBookingState: false,
      isLoadingUpdateResponsible: false,
      isLoadingGetWorkersNames: false,
      error: "",
      initialLoading: true,
    };
  },
  created() {
    // FT-082: restore filters + scope from the URL before the first load.
    const q = this.$route.query || {};
    if (q.scope === "inactive" && this.showActive) this.$store.commit("show_active_bookings");
    else if (q.scope === "active" && !this.showActive) this.$store.commit("show_active_bookings");
    this.readFiltersFromQuery();
  },
  mounted() {
    let self = this;
    this.initialLoading = true;
    // Сохраняем ID для безопасной отписки
    if (this.$store.getters.getCompany && this.$store.getters.getCompany.company) {
      this.subscribedCompanyId = this.$store.getters.getCompany.company.id;
    }
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
    this.clearBadge();
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (
        this.$tours["registrationTour"] &&
        this.$store.getters.getTourNextStep
      ) {
        this.$tours["registrationTour"].nextStep();
      }
      this.$store.commit("setNewBooking", false);
      // На активных грузит два раза, а при неактивных вообще не грузит, поэтому сделал так
      this.getDataFromApi();
      // Агент допущен: это не доступ к данным, а realtime-обновление того же
      // списка, который ему и так показан. Закрытие ничего не защищает.
      if ((this.isStaff || this.isAgent) &&
          this.$store.getters.getCompany && 
          this.$store.getters.getCompany.company && 
          this.$store.getters.getCompany.company.id) {
        // FT-066: native held-ref sub; handlers via arrows (this-rebinding). Mixin auto-unsubscribes.
        this.bookingsSub = this.$cableSubscribe(
          { channel: "BookingsChannel", room: this.$store.getters.getCompany.company.id },
          {
            connected: () => this.onBookingsConnected(),
            disconnected: () => this.onBookingsDisconnected(),
            received: (data) => this.onBookingsReceived(data),
          }
        );
      }
      if (self.$store.getters.getSortDateInBookings) {
        // setTimeout(
        //   () =>
        //     (self.sort_date = self.$store.getters.getSortDateInBookings),
        //   700
        // );
        self.sort_date = self.$store.getters.getSortDateInBookings;
      }

      if (self.$store.getters.getSortStateInBookings) {
        self.selected_booking_state =
          self.$store.getters.getSortStateInBookings;
      }
      // Удаляю из селекта перепробег
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.mileage_limit_cost == 0
      ) {
        this.add_services.splice(
          this.add_services.findIndex(
            (service) => service == "Превышение пробега"
          ),
          1
        );
      }
      // FT-066: health-check via native consumer (replaced the old wrapper-registry probe).
      // getConsumer().connection.isOpen() is the public @rails/actioncable API ("disconnected" =
      // !isOpen). The dead commented reconnect is dropped — native consumer auto-reopens on drop.
      // check every 30 seconds if action cable wss server is online
      function check_server() {
        self.check_server = setInterval(function () {
          const consumer = getConsumer();
          self.connected = !!(consumer && consumer.connection && consumer.connection.isOpen());
        }.bind(self), 30000);
      }
      check_server();
    } else {
      this.$store.commit("unsetCurrentUser");
      this.$router.push({ path: `/signin` }).catch((err) => { });
    }
  },
  beforeDestroy() {
    // FT-066: CableSubscriber mixin auto-unsubscribes the held BookingsChannel ref.
    this.$cableUnsubscribe(this.bookingsSub);
    this.bookingsSub = null;
  },
  // mounted: function() {
  //   if (this.$tours["registrationTour"]) {
  //     this.$tours["registrationTour"].nextStep();
  //   }
  // },
  destroyed() {
    clearInterval(this.check_server);
  },
  watch: {
    sort_date() {
      console.log("sort_date", this.sort_date);
      let self = this;
      if (this.sort_date) {
        this.sort_date_for_input = moment(this.sort_date).format("DD-MM-YYYY");
        this.$store.commit("setsortDateInBookings", this.sort_date);
      }
      if (
        this.$store.getters.getSortDateInBookings != null ||
        this.sort_date != null
      ) {
        this.$store.commit("setsortDateInBookings", this.sort_date);
        // this.getDataFromApi();
        this.sortForDate();
      } else {
        this.getDataFromApi();
        // this.active_bookings = [];
        // this.inactive_bookings = [];
        // this.bookings.map(function (booking) {
        //   if (booking.active == true) {
        //     self.active_bookings.push(booking);
        //   }
        // });
        // this.bookings.map(function (booking) {
        //   if (booking.active == false) {
        //     self.inactive_bookings.push(booking);
        //   }
        // });

        this.$store.commit("setsortDateInBookings", null);
      }
    },
    limitExept() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.mileage_limit_cost
      ) {
        if (this.limitExept) {
          this.limitCost = Math.round(
            this.returnMileageExt() *
            this.$store.getters.getCompany.company.mileage_limit_cost
          );
        } else {
          this.limitCost = 0;
        }
      }
    },
    tableOptions(pagination) {
      // Проверяем, что это не первоначальная загрузка
      if (this.initialLoading) {
        this.initialLoading = false;
        return;
      }

      // Сохраняем старые значения для сравнения
      const oldPage = this.page;
      const oldPerPage = this.per_page;
      const oldSortBy = this.sort_by;
      const oldDirection = this.direction;

      // Устанавливаем новые значения
      this.page = pagination.page;
      this.per_page = pagination.itemsPerPage;
      this.sort_by = pagination.sortBy[0] ? pagination.sortBy[0] : "";
      this.direction = pagination.sortDesc[0] ? "desc" : "asc";

      // FT-082: only reload when page/perPage/sort actually changed. Without this
      // guard, writing items back re-emits options -> reload -> loop. In the inactive
      // view table-1 drives the "inactive" bucket; the active view is one flat table.
      const changed =
        oldPage !== this.page ||
        oldPerPage !== this.per_page ||
        oldSortBy !== this.sort_by ||
        oldDirection !== this.direction;
      if (!changed) return;
      if (this.showActive) this.getDataFromApi();
      else this.loadBucket("inactive");
    },
    // FT-082: server pagination for the two extra inactive tables. First fire on
    // (re)mount is a no-op (reset by show_active_booking on every view switch); a
    // fire with unchanged page/sort is skipped so writing items back can't loop.
    ridedOptions(newVal, oldVal) {
      if (this.ridedInitial) {
        this.ridedInitial = false;
        return;
      }
      if (this.sameOptions(newVal, oldVal)) return;
      if (!this.showActive) this.loadBucket("rided");
    },
    depositOptions(newVal, oldVal) {
      if (this.depositInitial) {
        this.depositInitial = false;
        return;
      }
      if (this.sameOptions(newVal, oldVal)) return;
      if (!this.showActive) this.loadBucket("deposit");
    },
    search() {
      this.$store.commit("setSearchInBookings", this.search);
      if (this.search == "") {
        this.search = null;
      } else {
        let self = this;
        this.page = 1;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.getDataFromApi();
          }, 300); // delay
        }
        debounce();
      }
    },
    show_active_booking() {
      this.$store.commit("show_active_bookings");
      // FT-082: skip the first options-fire of each (re)mounted table in the new view.
      this.initialLoading = true;
      this.ridedInitial = true;
      this.depositInitial = true;
      this.page = 1;
      this.syncListUrl();
      this.getDataFromApi();
    },
    selected_booking_state() {
      // FT-082: state is filtered server-side (getDataFromApi sends `state`); each
      // bucket comes back already scoped, so no client-side re-bucketing needed.
      const states = this.selected_booking_state;
      this.$store.commit("setSortStateInBookings", states && states.length ? states : null);
      this.page = 1;
      this.getDataFromApi();
    },
  },
  computed: {
    selectedBookings() {
      let bookings = [];
      let inactive_bookings = this.inactive_bookings.filter((booking) => {
        return booking.selected;
      });
      inactive_bookings.forEach((booking) => {
        bookings.push(booking);
      });
      let rided_bookings = this.rided_bookings.filter((booking) => {
        return booking.selected;
      });
      rided_bookings.forEach((booking) => {
        bookings.push(booking);
      });
      return bookings;
    },
    selectedHeaders() {
      // Убираю выделение если активные брони
      let headers = [];
      if (this.isMobile) {
        this.headers.map((header) => {
          headers.push(header);
        });
        if (this.showActive) {
          headers.splice(0, 1);
        } else {
          headers.splice(3, 1);
        }
        // this.mobile_headers.map((header) => {
        //   headers.push(header);
        // });
        // if (!this.showActive) {
        //   headers.splice(0, 1);
        // } else {
        //   headers.splice(2, 1);
        // }
      } else {
        this.headers.map((header) => {
          headers.push(header);
        });
        if (this.showActive) {
          headers.splice(0, 1);
        } else {
          headers.splice(3, 1);
        }
      }
      return headers;
    },
    toolbar_height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 260
        case 'sm': return 260
        case 'md': return 110
        case 'lg': return 120
        case 'xl': return 120
        default: return 120
      }
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
    showActive() {
      return this.$store.getters.getShowActiveBookings;
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    // FT-082: table-1 shows the active table (isLoading) or the inactive bucket.
    mainTableLoading() {
      return this.showActive ? this.isLoading : this.inactiveLoading;
    },
    // opaque background so the skeleton overlay hides the stale rows underneath.
    skeletonStyle() {
      return { background: this.$vuetify.theme.dark ? "#1E1E1E" : "#FFFFFF" };
    },
  },
  methods: {
    // FT-082: fill the whole table height with skeleton rows. Real list rows are
    // ~2x the height of a skeleton row, so overshoot ~2x the visible count; the
    // excess is clipped by overflow:hidden. Capped to bound transient DOM.
    skeletonType(count) {
      // one skeleton row per real row (rows are height-matched to 67px in CSS);
      // +2 buffer guarantees no gap above the footer, excess hidden behind it.
      const rows = Math.min(Math.max((count || 8) + 2, 6), 200);
      return `table-thead, table-row-divider@${rows}`;
    },
    // FT-066: BookingsChannel handlers (moved 1:1 from the old declarative channel).
    onBookingsConnected() {
      this.connected = "success";
    },
    onBookingsDisconnected() {
      this.connected = "error";
    },
    onBookingsReceived(data) {
      // FT-082: the inactive view is server-paginated per bucket, so this.bookings
      // only holds the active table. Re-bucketing a partial set on a cable event
      // would wipe the inactive tables — refresh the current pages instead.
      if (!this.showActive) {
        if (this.realtimeTimeout) clearTimeout(this.realtimeTimeout);
        this.realtimeTimeout = setTimeout(() => this.getDataFromApi(), 400);
        return;
      }
      let self = this;
      if (data.action == "update") {
        // Вставляю платеж в массив платежей брони
        data.booking.counts = data.counts;
        this.bookings.forEach((booking) => {
          if (booking.id == data.booking.id) {
            this.bookings.splice(this.bookings.indexOf(booking), 1);
            this.bookings.unshift(data.booking);
          }
        });
        self.active_bookings = [];
        self.inactive_bookings = [];
        self.filtered_inactive_bookings = [];
        self.rided_bookings = [];
        self.filtered_rided_bookings = [];
        self.part_return_deposit_bookings = [];

        this.bookings.forEach(function (booking) {
          if (booking.active == true) {
            booking["new"] = false;
            self.active_bookings.push(booking);
          }
        });
        this.bookings.forEach(function (booking) {
          if (booking.active == false) {
            booking["new"] = false;
            if (booking.part_return_deposit) {
              self.part_return_deposit_bookings.push(booking);
            } else if (!booking.part_return_deposit && !booking.ride) {
              self.inactive_bookings.push(booking);
              self.filtered_inactive_bookings.push(booking);
            } else {
              self.rided_bookings.push(booking);
              self.filtered_rided_bookings.push(booking);
            }
          }
        });
        this.showBooking();
      } else if (data.action == "new") {
        let new_check = this.bookings.findIndex(
          (booking) => booking.id == data.booking.id
        );
        if (new_check == -1) {
          // Вставляю платеж в массив платежей брони
          data.booking.counts = data.counts;
          data.booking.new = true;
          this.bookings.push(data.booking);
          this.active_bookings = [];
          this.inactive_bookings = [];
          this.filtered_inactive_bookings = [];
          this.rided_bookings = [];
          this.filtered_rided_bookings = [];
          this.part_return_deposit_bookings = [];

          this.bookings.forEach(function (booking) {
            if (booking.active == true) {
              self.active_bookings.push(booking);
            }
          });
          this.bookings.forEach(function (booking) {
            if (booking.active == false) {
              booking["new"] = false;
              if (booking.part_return_deposit) {
                self.part_return_deposit_bookings.push(booking);
              } else if (!booking.part_return_deposit && !booking.ride) {
                self.inactive_bookings.push(booking);
                self.filtered_inactive_bookings.push(booking);
              } else {
                self.rided_bookings.push(booking);
                self.filtered_rided_bookings.push(booking);
              }
            }
          });
          this.showBooking();
        }
      } else if (data.action == "destroy") {
        this.bookings.forEach((booking) => {
          if (booking.id == data.booking) {
            this.bookings.splice(this.bookings.indexOf(booking), 1);
          }
        });
        this.active_bookings.forEach((booking) => {
          if (booking.id == data.booking) {
            this.active_bookings.splice(
              this.active_bookings.indexOf(booking),
              1
            );
          }
        });
        this.inactive_bookings.forEach((booking) => {
          if (booking.id == data.booking) {
            this.inactive_bookings.splice(
              this.inactive_bookings.indexOf(booking),
              1
            );
          }
        });
        this.filtered_inactive_bookings.forEach((booking) => {
          if (booking.id == data.booking) {
            this.filtered_inactive_bookings.splice(
              this.filtered_inactive_bookings.indexOf(booking),
              1
            );
          }
        });
        this.rided_bookings.forEach((booking) => {
          if (booking.id == data.booking) {
            this.rided_bookings.splice(
              this.rided_bookings.indexOf(booking),
              1
            );
          }
        });
        this.filtered_rided_bookings.forEach((booking) => {
          if (booking.id == data.booking) {
            this.filtered_rided_bookings.splice(
              this.filtered_rided_bookings.indexOf(booking),
              1
            );
          }
        });
        this.part_return_deposit_bookings.forEach((booking) => {
          if (booking.id == data.booking) {
            this.part_return_deposit_bookings.splice(
              this.part_return_deposit_bookings.indexOf(booking),
              1
            );
          }
        });
      }
      // Сортирую на дату если включен фильтр
      if (
        this.$store.getters.getSortDateInBookings != null ||
        this.sort_date != null
      ) {
        this.sortForDate();
      }
    },
    // FT-082: JSON:API row -> plain attributes with counts + full_name.
    parseListRow(row, included) {
      let a = row.attributes;
      a.counts = [];
      const rel = row.relationships && row.relationships.counts;
      const links = rel && rel.data ? rel.data : [];
      links.forEach((item) => {
        (included || [])
          .filter((count) => count.id == item.id)
          .forEach((count) => a.counts.push(count.attributes));
      });
      a.full_name = a.entity ? `${a.entity_name}` : `${a.last_name} ${a.first_name}`;
      a["new"] = false;
      return a;
    },
    // col = { bookings: { data, included }, total }
    parseListCol(col) {
      if (!col || !col.bookings) return [];
      return (col.bookings.data || []).map((row) =>
        this.parseListRow(row, col.bookings.included)
      );
    },
    // FT-082: true when two v-data-table option objects mean the same page/sort.
    sameOptions(a, b) {
      if (!a || !b) return false;
      return (
        a.page === b.page &&
        a.itemsPerPage === b.itemsPerPage &&
        (a.sortBy && a.sortBy[0]) === (b.sortBy && b.sortBy[0]) &&
        (a.sortDesc && a.sortDesc[0]) === (b.sortDesc && b.sortDesc[0])
      );
    },
    getDataFromApi() {
      // a call fired while another is in flight isn't dropped: remember it and
      // refetch once the current one settles, so the view matches the latest filters.
      if (this.isLoading) {
        this.reloadPending = true;
        return;
      }
      this.isLoading = true;
      if (!this.showActive) {
        this.inactiveLoading = true;
        this.ridedLoading = true;
        this.depositLoading = true;
      }
      const params = {
        per_page: this.per_page,
        sort_by: this.sort_by,
        direction: this.direction,
        active: this.showActive,
        ...this.filterParams(),
      };
      // active view is a single server-paginated table; inactive view asks for
      // all three buckets at once (each page 1 — the backend paginates per bucket).
      if (this.showActive) params.page = this.page;
      this.axios
        .post(`/api/v1/bookings/list`, params, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          this.bookings = [];
          this.active_bookings = [];
          this.inactive_bookings = [];
          this.rided_bookings = [];
          this.filtered_rided_bookings = [];
          this.part_return_deposit_bookings = [];
          this.filtered_inactive_bookings = [];

          if (this.showActive) {
            const rows = this.parseListCol({ bookings: response.data.bookings });
            this.bookings = rows;
            this.active_bookings = rows;
            this.total = response.data.total;
          } else {
            const cols = response.data.columns || {};
            this.inactive_bookings = this.parseListCol(cols.inactive);
            this.filtered_inactive_bookings = this.inactive_bookings.slice();
            this.total = cols.inactive ? cols.inactive.total : 0;
            this.rided_bookings = this.parseListCol(cols.rided);
            this.filtered_rided_bookings = this.rided_bookings.slice();
            this.ridedTotal = cols.rided ? cols.rided.total : 0;
            this.part_return_deposit_bookings = this.parseListCol(cols.deposit);
            this.depositTotal = cols.deposit ? cols.deposit.total : 0;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.bookings_load"));
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.initialLoading = false;
          this.inactiveLoading = false;
          this.ridedLoading = false;
          this.depositLoading = false;
          if (this.reloadPending) {
            this.reloadPending = false;
            this.getDataFromApi();
          }
        });
    },
    // FT-082: load a single inactive table's page (footer paging / column sort),
    // mirrors the board's per-column `bucket` load. name = inactive|rided|deposit.
    loadBucket(name) {
      const opt =
        name === "rided"
          ? this.ridedOptions
          : name === "deposit"
            ? this.depositOptions
            : this.tableOptions;
      const params = {
        active: false,
        bucket: name,
        page: opt.page || 1,
        per_page: opt.itemsPerPage || this.per_page,
        sort_by: opt.sortBy && opt.sortBy[0] ? opt.sortBy[0] : this.sort_by,
        direction: opt.sortDesc && opt.sortDesc[0] ? "desc" : "asc",
        ...this.filterParams(),
      };
      // per-table skeleton only (not the global loader) while this page loads
      const flag =
        name === "rided" ? "ridedLoading" : name === "deposit" ? "depositLoading" : "inactiveLoading";
      this[flag] = true;
      this.axios
        .post(`/api/v1/bookings/list`, params, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          const col = (response.data.columns || {})[name];
          if (!col) return;
          const rows = this.parseListCol(col);
          if (name === "rided") {
            this.rided_bookings = rows;
            this.filtered_rided_bookings = rows.slice();
            this.ridedTotal = col.total;
          } else if (name === "deposit") {
            this.part_return_deposit_bookings = rows;
            this.depositTotal = col.total;
          } else {
            this.inactive_bookings = rows;
            this.filtered_inactive_bookings = rows.slice();
            this.total = col.total;
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.bookings_load"));
          console.log(error);
        })
        .finally(() => {
          this[flag] = false;
        });
    },
    paymentOptions() {
      return {
        t: (key, params) => this.$t(key, params),
        currency: (this.company && this.company.currency) || "",
        multicurrency: Boolean(this.company && this.company.multicurrency_cashboxes == true),
      };
    },
    // Строка старого контракта ($t("bookings.paid") | "+ N" | " -N") — её
    // сравнивают с $t("bookings.paid") в :disabled и тултипах выше.
    calculatePayments(booking) {
      return legacyPaymentLabel(booking, this.paymentOptions());
    },
    // Подпись кнопки оплаты — общий с доской хелпер: «To pay 417 ₽» вместо «-417».
    paymentChipLabel(booking) {
      const chip = bookingPaymentChip(booking, this.paymentOptions());
      return chip ? chip.label : "";
    },
    selectColorPaid(booking) {
      const chip = bookingPaymentChip(booking, this.paymentOptions());
      return chip ? chip.color : undefined;
    },
    // Условие показа расчётной кнопки — общее с чипом доски (v-if в трёх блоках).
    showsPaymentChip(booking) {
      return hasPaymentChip(booking);
    },
    checkMileageLimit(mileage) {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.mileage_limit
      ) {
        let limit = this.$store.getters.getCompany.company.mileage_limit;
        if (mileage > limit) {
          this.limitExept = true;
          return true;
        } else {
          this.limitExept = false;
          return false;
        }
      }
    },
    returnMileageExt() {
      if (this.$store.getters.getCompany.company && this.editedBooking) {
        return Math.round(
          ((this.editedBooking.end_mileage - this.editedBooking.start_mileage) /
            this.editedBooking.days -
            this.$store.getters.getCompany.company.mileage_limit) *
          this.editedBooking.days
        );
      }
    },
    getStateIcon(state) {
      switch (state) {
        case 'Новая': return 'mdi-new-box'
        case 'Подтверждена': return 'mdi-check-all'
        case 'Не подтверждена': return 'mdi-cellphone-basic'
        case 'В обработке': return 'mdi-autorenew'
        case 'Отказ клиента': return 'mdi-account-remove-outline'
        case 'Нет машин': return 'mdi-car-off'
        case 'Недозвон': return 'mdi-phone-off-outline'
        case 'Ожидает ответа клиента': return 'mdi-account-question-outline'
        case 'Ожидает оплаты': return 'mdi-currency-usd-off'
        case 'Активная': return 'mdi-alpha-a-circle-outline'
        case 'Отмена': return 'mdi-cancel'
        case 'Отъездила': return 'mdi-garage-variant'
        case 'Вернуть залог': return 'mdi-keyboard-return'
        default: return 'mdi-head-question-outline'
      }
    },
    getStateTooltip(state) {
      const translations = {
        'Новая': this.$t('bookings_states.new'),
        'В обработке': this.$t('bookings_states.in_work'),
        'Отказ клиента': this.$t('bookings_states.decline'),
        'Нет машин': this.$t('bookings_states.no_cars'),
        'Недозвон': this.$t('bookings_states.abandoned'),
        'Ожидает ответа клиента': this.$t('bookings_states.wait_answer'),
        'Ожидает оплаты': this.$t('bookings_states.wait_pay'),
        'Активная': this.$t('bookings_states.active'),
        'Отмена': this.$t('bookings_states.cancel'),
        'Отъездила': this.$t('bookings_states.rided'),
        'Вернуть залог': this.$t('bookings_states.return_deposit'),
        'Подтверждена': this.$t('bookings_states.accepted'),
        'Не подтверждена': this.$t('bookings_states.not_accepted'),
        'Другое': this.$t('bookings_states.other')
      }
      return translations[state] || state
    },
    getStateColor(state) {
      switch (state) {
        case 'Новая': return 'primary'
        case 'Подтверждена': return 'success'
        case 'Не подтверждена': return 'warning'
        case 'В обработке': return 'primary'
        case 'Отказ клиента': return 'error'
        case 'Нет машин': return 'secondary'
        case 'Недозвон': return 'warning'
        case 'Ожидает ответа клиента': return 'pink'
        case 'Ожидает оплаты': return 'lime'
        case 'Активная': return 'light-blue'
        case 'Отмена': return 'brown'
        case 'Отъездила': return 'light-green'
        case 'Вернуть залог': return 'blue'
        default: return 'secondary'
      }
    },
    onStartChange(selectedDates, dateStr, instance) {
      this.$set(this.configEnd, "minDate", dateStr);
    },
    checkPartReturnDepositDay(booking) {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.part_return_deposit_days &&
        this.$store.getters.getCompany.company.part_return_deposit_days > 0 &&
        moment().isSameOrAfter(
          moment(booking.end_date, "DD-MM-YYYY H:mm").add(
            this.$store.getters.getCompany.company.part_return_deposit_days,
            "days"
          ),
          "day"
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    saveDescriptionEdit() {
      if (this.isStaff || this.agentCan("can_edit_booking")) {
        let self = this;
        if (this.descriptionEdit && this.showDescriptionEditId) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/bookings/${self.showDescriptionEditId}`,
              {
                bookings: {
                  description: self.descriptionEdit,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              let foundIndex = this.bookings.findIndex(
                (element) => element.id === self.showDescriptionEditId
              );
              this.bookings[foundIndex].description = this.descriptionEdit;
              self.descriptionEdit = null;
              self.showDescriptionEditId = null;
              self.showDescriptionEditDialog = false;
            })
            .catch((error) => {
              this.setError(error, this.$t("bookings.booking_desc"));

            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    showPayments(booking) {
      if (booking.counts) {
        if (booking.counts.length > 0) {
          return true;
        }
      }
    },
    returnDepositSum(booking) {
      if (booking && booking != undefined) {
        let paid = 0;
        booking.counts.forEach((count) => {
          // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
          if (count.completed) {
            if (count.operation) {
              if (this.company && this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid += ratedSum;
              } else {
                let sum = Number(count.sum);
                paid += sum;
              }
            } else {
              if (this.company && this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid -= ratedSum;
              } else {
                let sum = Number(count.sum);
                paid -= sum;
              }
            }
          }
        });

        // Проверяем что значения числовые
        let check_number_rental_cost = Number(booking.rental_cost) === booking.rental_cost;
        let check_number_delivery = Number(booking.delivery) === booking.delivery;
        let check_number_delivery_end = Number(booking.delivery_end) === booking.delivery_end;
        let check_number_equipment = Number(booking.equipment) === booking.equipment;
        let check_number_insurance = Number(booking.insurance) === booking.insurance;
        let check_number_clean_payment = Number(booking.clean_payment) === booking.clean_payment;
        let check_number_add_drivers_cost = Number(booking.add_drivers_cost) === booking.add_drivers_cost;
        let check_number_hours_cost = Number(booking.hours_cost) === booking.hours_cost;
        let check_number_hours_cost_end = Number(booking.hours_cost_end) === booking.hours_cost_end;
        let check_number_mileage_cost = Number(booking.mileage_cost) === booking.mileage_cost;
        let check_number_damage = Number(booking.damage) === booking.damage;
        let check_number_gas = Number(booking.gas) === booking.gas;
        let check_number_fine = Number(booking.fine) === booking.fine;
        let check_number_other = Number(booking.other) === booking.other;
        let check_number_other_end = Number(booking.other_end) === booking.other_end;
        // FT-102 REQ-07: каталожное оборудование — компонент суммы «к оплате»
        let check_number_addons_cost = Number(booking.addons_cost) === booking.addons_cost;
        let rental_cost = check_number_rental_cost ? booking.rental_cost : 0;
        let delivery = check_number_delivery ? booking.delivery : 0;
        let delivery_end = check_number_delivery_end ? booking.delivery_end : 0;
        let equipment = check_number_equipment ? booking.equipment : 0;
        let insurance = check_number_insurance ? booking.insurance : 0;
        let clean_payment = check_number_clean_payment ? booking.clean_payment : 0;
        let add_drivers_cost = check_number_add_drivers_cost ? booking.add_drivers_cost : 0;
        let hours_cost = check_number_hours_cost ? booking.hours_cost : 0;
        let mileage_cost = check_number_mileage_cost ? booking.mileage_cost : 0;
        let damage = check_number_damage ? booking.damage : 0;
        let gas = check_number_gas ? booking.gas : 0;
        let fine = check_number_fine ? booking.fine : 0;
        let other = check_number_other ? booking.other : 0;
        let other_end = check_number_other_end ? booking.other_end : 0;
        let hours_cost_end = check_number_hours_cost_end ? booking.hours_cost_end : 0;
        let addons_cost = check_number_addons_cost ? booking.addons_cost : 0;
        let booking_sum =
          parseFloat((rental_cost +
            delivery +
            delivery_end +
            equipment +
            addons_cost +
            insurance +
            clean_payment +
            add_drivers_cost +
            hours_cost +
            mileage_cost +
            damage +
            gas +
            fine +
            other +
            other_end +
            hours_cost_end).toFixed(2));
        // Округляем сумму до 2 знаков после запятой
        booking_sum = parseFloat(booking_sum.toFixed(2));
        paid = parseFloat(paid.toFixed(2));

        return paid - booking_sum;
      }
    },
    checkLateDate(date) {
      if (!moment().isSameOrBefore(moment(date, "DD-MM-YYYY H:mm"), "day")) {
        return "color: tomato;";
      }
    },
    checkAddPayment(type) {
      if (this.selected_add_services.find((item) => item == type)) {
        return true;
      } else {
        return false;
      }
    },
    sortForDate() {
      let self = this;
      this.active_bookings = [];
      this.inactive_bookings = [];
      this.rided_bookings = [];
      this.bookings.map(function (booking) {
        if (booking.active == true) {
          self.active_bookings.push(booking);
        }
      });
      this.bookings.map(function (booking) {
        if (booking.active == false) {
          self.inactive_bookings.push(booking);
        }
      });
      this.active_bookings = this.active_bookings.filter(
        (x) =>
          moment(self.sort_date, "YYYY-MM-DD").isSame(
            moment(x.start_date, "DD-MM-YYYY H:mm"),
            "day"
          ) ||
          moment(self.sort_date, "YYYY-MM-DD").isSame(
            moment(x.end_date, "DD-MM-YYYY H:mm"),
            "day"
          )
      );
      this.inactive_bookings = this.inactive_bookings.filter(
        (x) =>
          moment(self.sort_date, "YYYY-MM-DD").isSame(
            moment(x.start_date, "DD-MM-YYYY H:mm"),
            "day"
          ) ||
          moment(self.sort_date, "YYYY-MM-DD").isSame(
            moment(x.end_date, "DD-MM-YYYY H:mm"),
            "day"
          )
      );
      this.rided_bookings = this.rided_bookings.filter(
        (x) =>
          moment(self.sort_date, "YYYY-MM-DD").isSame(
            moment(x.start_date, "DD-MM-YYYY H:mm"),
            "day"
          ) ||
          moment(self.sort_date, "YYYY-MM-DD").isSame(
            moment(x.end_date, "DD-MM-YYYY H:mm"),
            "day"
          )
      );

      this.active_bookings.forEach((booking) => {
        if (booking.in_rent) {
          booking.time = moment(booking.end_date, "DD-MM-YYYY H:mm").format(
            "DD-MM-YYYY H:mm"
          );
        } else {
          booking.time = moment(booking.start_date, "DD-MM-YYYY H:mm").format(
            "DD-MM-YYYY H:mm"
          );
        }
      });
      this.active_bookings = this.active_bookings.sort(function (x1, x2) {
        if (
          moment(x1.time, "DD-MM-YYYY H:mm").isBefore(
            moment(x2.time, "DD-MM-YYYY H:mm")
          )
        )
          return -1;
        if (
          moment(x1.time, "DD-MM-YYYY H:mm").isAfter(
            moment(x2.time, "DD-MM-YYYY H:mm")
          )
        )
          return 1;
        return 0;
      });

      this.inactive_bookings.forEach((booking) => {
        if (booking.in_rent) {
          booking.time = moment(booking.end_date, "DD-MM-YYYY H:mm").format(
            "DD-MM-YYYY H:mm"
          );
        } else {
          booking.time = moment(booking.start_date, "DD-MM-YYYY H:mm").format(
            "DD-MM-YYYY H:mm"
          );
        }
      });
      this.inactive_bookings = this.inactive_bookings.sort(function (x1, x2) {
        if (
          moment(x1.time, "DD-MM-YYYY H:mm").isBefore(
            moment(x2.time, "DD-MM-YYYY H:mm")
          )
        )
          return -1;
        if (
          moment(x1.time, "DD-MM-YYYY H:mm").isAfter(
            moment(x2.time, "DD-MM-YYYY H:mm")
          )
        )
          return 1;
        return 0;
      });
      this.rided_bookings.forEach((booking) => {
        if (booking.in_rent) {
          booking.time = moment(booking.end_date, "DD-MM-YYYY H:mm").format(
            "DD-MM-YYYY H:mm"
          );
        } else {
          booking.time = moment(booking.start_date, "DD-MM-YYYY H:mm").format(
            "DD-MM-YYYY H:mm"
          );
        }
      });
      this.rided_bookings = this.rided_bookings.sort(function (x1, x2) {
        if (
          moment(x1.time, "DD-MM-YYYY H:mm").isBefore(
            moment(x2.time, "DD-MM-YYYY H:mm")
          )
        )
          return -1;
        if (
          moment(x1.time, "DD-MM-YYYY H:mm").isAfter(
            moment(x2.time, "DD-MM-YYYY H:mm")
          )
        )
          return 1;
        return 0;
      });
    },
    clearSortDate() {
      this.$store.commit('setsortDateInBookings', null);
      this.sort_date = null;
      this.sort_date_for_input = null;
      this.menu_sort_date = false;
      this.getDataFromApi();
    },
    showBooking() {
      if (!this.showActive) {
        return this.inactive_bookings;
      } else {
        return this.active_bookings;
      }
    },
    // FT-082: scope segmented group. Active/inactive is a binary view, so pick =
    // flip when it differs (show_active_booking watcher commits + reloads).
    setScope(active) {
      if (this.showActive === active) return;
      this.show_active_booking = !this.show_active_booking;
    },
    // FT-082: shared filter toolbar plumbing (mirrors the board). Sort is NOT here —
    // the list sorts via its data-table columns (toolbar sort hidden).
    filterParams() {
      const f = this.filters;
      const p = {};
      if (f.search) p.search = f.search;
      if (f.state && f.state.length) p.state = f.state;
      if (f.car_id) p.car_id = f.car_id;
      if (f.responsible) p.responsible = f.responsible;
      if (f.date_from) p.date_from = f.date_from;
      if (f.date_to) p.date_to = f.date_to;
      if (f.payment_status) p.payment_status = f.payment_status;
      if (f.overdue) p.overdue = true;
      return p;
    },
    onFilters(f) {
      this.filters = f;
      this.page = 1;
      this.syncListUrl();
      this.getDataFromApi();
    },
    onReset() {
      this.filters = {
        search: null,
        state: [],
        car_id: null,
        responsible: null,
        date_from: null,
        date_to: null,
        payment_status: null,
        overdue: false,
        deposit_return: false,
      };
      this.page = 1;
      this.syncListUrl();
      this.getDataFromApi();
    },
    // FT-082: list URL always carries scope so a shared link opens the right tab.
    syncListUrl() {
      this.writeFiltersToQuery({ scope: this.showActive ? "active" : "inactive" });
    },
    loadCarsOnce() {
      if (this._carsLoaded) return;
      this._carsLoaded = true;
      this.loadCars();
    },
    loadResponsiblesOnce() {
      if (this._respLoaded) return;
      this._respLoaded = true;
      this.loadResponsibles();
    },
    loadCars() {
      this.carsLoading = true;
      this.axios
        .get("/api/v1/active_cars_for_new_booking", { headers: { Authorization: this.$store.getters.getAuthToken } })
        .then((response) => {
          this.cars = (response.data.cars.data || []).map((entry) => entry.attributes);
        })
        .catch((error) => console.log(error))
        .finally(() => { this.carsLoading = false; });
    },
    loadResponsibles() {
      this.responsiblesLoading = true;
      this.axios
        .get("/api/v1/get_workers_names_with_ids", { headers: { Authorization: this.$store.getters.getAuthToken } })
        .then((response) => {
          this.responsibles = response.data;
        })
        .catch((error) => console.log(error))
        .finally(() => { this.responsiblesLoading = false; });
    },
    archiveBookings() {
      this.$confirm({
        title: this.$t("bookings.archivate_bookings"),
        text: this.$t("bookings.archivate_bookings_desc"),
        icon: "mdi-alert-circle-outline",
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
      }).then((result) => {
        if (result) {
          this.isLoading = true;
          this.axios
            .post(
              `/api/v1/archivate_bookings`,
              {
                bookings: this.selectedBookings.map((item) => item.id),
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.selectedBookings.forEach((booking) => {
                console.log(
                  this.bookings.indexOf(booking),
                  this.inactive_bookings.indexOf(booking),
                  this.rided_bookings.indexOf(booking)
                );
                let booking_index = this.bookings.indexOf(booking);
                let inactive_booking_index =
                  this.inactive_bookings.indexOf(booking);
                let rided_booking_index = this.rided_bookings.indexOf(booking);
                if (booking_index > -1) {
                  this.bookings.splice(booking_index, 1);
                }
                if (inactive_booking_index > -1) {
                  this.inactive_bookings.splice(inactive_booking_index, 1);
                }
                if (rided_booking_index > -1) {
                  this.rided_bookings.splice(rided_booking_index, 1);
                }
              });
              this.$notify(this.$t("bookings.archivate"), "", "success");
            })
            .catch((error) => {
              this.isLoading = false;
              this.setError(error, this.$t("errors.bad_archivate"));
            })
            .finally(() => (this.isLoading = false));
        }
      });
    },
    toggleShowBookings() {
      // this.getDataFromApi();
      return this.$store.commit("show_active_bookings");
    },
    updateState(id, state) {
      if (this.isStaff) {
        this.isLoading = true;
        let self = this;
        this.axios
          .patch(
            `/api/v1/fines/${id}`,
            {
              fines: {
                state: state,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let foundIndex = this.fines.findIndex(
              (element) => element.id === id
            );
            this.fines.splice(foundIndex, 1, response.data);

            this.$notify(this.$t("bookings.fine_update_title"), this.$t("bookings.fine_update_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.edit_fines"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    stateColor(state) {
      if (state == "Оповещён") {
        return "warning";
      }
      if (state == "Оплачен") {
        return "red";
      }
      if (state == "Возмещён") {
        return "success";
      }
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        // console.log(moment(a.start_date, 'DD-MM-YYYY H:mm').isBefore(b.start_date, 'DD-MM-YYYY H:mm'))
        // if (index[0] === "start_date") {
        return moment(a.start_date, "DD-MM-YYYY H:mm").isBefore(
          moment(b.start_date, "DD-MM-YYYY H:mm")
        );
        // }
      });
      return items;
    },
    clearBadge() {
      if (this.isNative) {
        const clear = async () => {
          try {
            await Badge.clear();
          } catch (error) {
            if (error.code !== 'UNIMPLEMENTED') {
              console.error('Badge clear error:', error);
            }
          }
        };
        clear();
      }
    },
    formatCreatedAt(date) {
      return moment.parseZone(date).format("DD MMM H:mm");
    },
    formatBookingDates(date) {
      return moment(date, "DD-MM-YYYY H:mm").format("DD MMM H:mm");
    },
    formatDateBookingDates(date) {
      return moment(date, "DD-MM-YYYY H:mm").format("DD MMM");
    },
    formatTimeBookingDates(date) {
      return moment(date, "DD-MM-YYYY H:mm").format("H:mm");
    },
    shortFormatBookingDates(date) {
      return moment(date, "DD-MM-YYYY H:mm").format("DD-MM H:mm");
    },
    replaceToBooking(booking) {
      this.$router.push({ path: `/bookings/${booking.id}` });
    },
    setCarStateClass(state) {
      // let car = this.cars.find(car => car.code === code)
      if (state) {
        // В ремонте
        if (state == 1) {
          return "green--text";
        } else if (state == 2) {
          if (this.$vuetify.theme.dark) {
            return "grey--text text--darken-2";
          } else {
            return "black--text";
          }
        } else if (state == 3) {
          return "red--text";
        } else if (state == 4) {
          return "pink--text";
        } else if (state == 5) {
          return "blue--text";
        } else if (state == 6) {
          return "orange--text";
        }
      }
    },
    setCarStateTooltip(state) {
      // let car = this.cars.find(car => car.code === code)
      if (state) {
        // В ремонте
        if (state == 1) {
          return this.$t("states.normal");
        } else if (state == 2) {
          return this.$t("states.in_service");
        } else if (state == 3) {
          return this.$t("states.critical_2");
        } else if (state == 4) {
          return this.$t("states.long_rent");
        } else if (state == 5) {
          return this.$t("states.no_rent");
        } else if (state == 6) {
          return this.$t("states.service_needed");
        }
      }
    },
    setClient(id) {
      let client = this.clients.filter((x) => x.id === id);
      // Warning fio
      this.clients_arr.push(client);
    },
    getWorkersNames() {
      this.isLoadingGetWorkersNames = true;
      this.axios
        .get("/api/v1/get_workers_names_with_ids", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.workers_names = response.data;
          this.responsibles = response.data;
          // добавляем в массив отсутствие ответственного
          this.responsibles.push({
            id: null,
            name: null,
          });
        })
        .catch((error) => {
          this.setError(error, "Something went wrong in get_workers_names");
          console.log(error);
        })
        .finally(() => (this.isLoadingGetWorkersNames = false));
    },
    updateResponsible(id, responsible_name, responsible_id) {
      if (this.isStaff) {
        this.isLoadingUpdateResponsible = true;
        let self = this;
        this.axios
          .patch(
            `/api/v1/update_responsible`,
            {
              bookings: {
                id: id,
                responsible: responsible_name,
                responsible_id: responsible_id
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let foundIndex = this.bookings.findIndex(
              (element) => element.id === self.updatingBookingId
            );
            this.bookings[foundIndex].responsible = self.selected_worker;
            let foundIndex1 = this.active_bookings.findIndex(
              (element) => element.id === self.updatingBookingId
            );
            if (foundIndex1 >= 0) {
              this.active_bookings[foundIndex1].responsible =
                responsible_name;
            }
            let foundIndex2 = this.inactive_bookings.findIndex(
              (element) => element.id === self.updatingBookingId
            );
            if (foundIndex2 >= 0) {
              this.inactive_bookings[foundIndex2].responsible =
                responsible_name;
            }

            this.selected_worker = "";
            this.updatingBookingId = null;

            this.$notify(this.$t("bookings.responsible_changed_title"), this.$t("bookings.responsible_changed_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.change_responsible"));
          })
          .finally(() => (this.isLoadingUpdateResponsible = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveResponsibale() {
      if (this.isStaff) {
        let self = this;
        if (this.selected_worker != null && this.selected_worker != "" && this.updatingBookingId) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/bookings/${self.updatingBookingId}`,
              {
                bookings: {
                  responsible: self.selected_worker,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              let foundIndex = this.bookings.findIndex(
                (element) => element.id === self.updatingBookingId
              );
              this.bookings[foundIndex].responsible = self.selected_worker;
              let foundIndex1 = this.active_bookings.findIndex(
                (element) => element.id === self.updatingBookingId
              );
              if (foundIndex1 >= 0) {
                this.active_bookings[foundIndex1].responsible =
                  self.selected_worker;
              }
              let foundIndex2 = this.inactive_bookings.findIndex(
                (element) => element.id === self.updatingBookingId
              );
              if (foundIndex2 >= 0) {
                this.inactive_bookings[foundIndex2].responsible =
                  self.selected_worker;
              }

              this.selected_worker = "";
              this.updatingBookingId = null;
              this.showSetResponsible = false;
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.select_resp_text"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.select_resp"), this.error, "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveBookingState(state, id) {
      if (this.isStaff || this.agentCan("can_edit_booking")) {
        if ((state, id)) {
          if (state == "Отъездила" || state == "Активная") {
            this.$notify(this.$t("errors.warning_title"), this.$t("bookings_states.select_state_warning_active_rided"), "warning", 3000);
          }
          this.updatingBookingId = id;
          this.isLoadingSaveBookingState = true;
          this.axios
            .patch(
              `/api/v1/bookings/${id}`,
              {
                bookings: {
                  state: state,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              let foundIndex = this.bookings.findIndex(
                (element) => element.id === id
              );
              this.bookings[foundIndex].state = state;
              let foundIndex1 = this.active_bookings.findIndex(
                (element) => element.id === id
              );
              if (foundIndex1 >= 0) {
                this.active_bookings[foundIndex1].state = state;
              }
              let foundIndex2 = this.inactive_bookings.findIndex(
                (element) => element.id === id
              );
              if (foundIndex2 >= 0) {
                this.inactive_bookings[foundIndex2].state = state;
              }
              this.showSetBookingState = false;
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.update_state"));
            })
            .finally(() => (this.isLoadingSaveBookingState = false, this.updatingBookingId = null));
        } else {
          this.$notify(this.$t("errors.select_state"), this.error, "error", 3000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    checkClientCategory(booking) {
      // let client = this.clients.find(x => x.id == client_id)
      if (booking.client_category == "Новый") {
        return "";
      } else if (
        booking.client_category == "Постоянный" &&
        !booking.client_debtor
      ) {
        return `green--text`;
      } else if (booking.client_category == "Серый" && !booking.client_debtor) {
        return `grey--text text-decoration-line-through`;
      } else if (
        booking.client_category == "Чёрный" &&
        !booking.client_debtor
      ) {
        return `black--text text-decoration-line-through`;
      } else if (
        booking.client_category == "Лояльный" &&
        !booking.client_debtor
      ) {
        return `deep-purple--text`;
      } else if (booking.client_debtor) {
        return `orange darken-4 white--text`;
      }
    },
    selectColorBooking(booking) {
      const classes = [];
      if (booking.technical == true) {
        classes.push(this.$vuetify.theme.dark ? 'blue-grey darken-3' : 'blue-grey lighten-1');
      }
      // неактивная бронь приглушается, чтобы статус читался с первого взгляда
      if (booking.active === false) classes.push('row-inactive');
      return classes.join(' ');
    },
    selectColorRidedBooking(booking) {
      if (this.checkPartReturnDepositDay(booking)) {
        // сигнал «вернуть залог» важнее приглушения — не миксуем
        if (this.$vuetify.theme.dark) {
          return 'yellow darken-2';
        } else {
          return 'warning lighten-2';
        }
      }
      if (booking.active === false) return 'row-inactive';
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
  components: {
    BookingStateMenu,
    BookingsCommandBar,
  },
};
</script>
<style>
.pulse {
  border-radius: 50%;
  margin: 10px;
  height: 20px;
  width: 20px;
  transform: scale(1);
}

.pulse.pulse_success {
  background: rgba(0, 179, 0, 1);
  box-shadow: 0 0 0 0 rgba(0, 179, 0, 1);
  animation: pulse-green 2s infinite;
}

.pulse.pulse_error {
  background: rgb(239, 24, 24);
  box-shadow: 0 0 0 0 rgb(239, 24, 24);
  animation: pulse-error 2s infinite;
}

@keyframes pulse-green {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
  }
}

@keyframes pulse-error {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(217, 51, 51, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(217, 51, 51, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(217, 51, 51, 0);
  }
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 10px;
}

.description-trunc p {
  margin: 0px;
}

.payment .v-label {
  font-size: 12px !important;
}

.is-mobile .v-data-footer__select {
  margin-right: 0 !important;
}

.is-mobile .v-data-footer__icons-before {
  margin: 0 auto !important;
}

.is-mobile .v-data-footer__icons-after {
  margin: 0 auto !important;
}
</style>
<style scoped>
/* неактивная бронь: строка приглушена, статус виден без чтения полей */
tr.row-inactive td {
  opacity: 0.55;
}
.board-header__title {
  font-size: 1.15rem;
  font-weight: 600;
  letter-spacing: 0.01em;
}
/* Segmented view switch: quiet until active */
.board-header__switch >>> .v-btn {
  text-transform: none;
  letter-spacing: 0;
}
/* FT-082: skeleton overlay while a table's page loads (replaces the linear loader) */
.list-table-wrap {
  position: relative;
}
.list-table-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  overflow: hidden;
}
/* match a real data row (67px) so skeleton rows line up 1:1 with the table */
.list-table-skeleton >>> .v-skeleton-loader__table-cell {
  height: 67px;
}
/* Lift the real footer above the skeleton with an opaque bg, so the overshoot rows
   are hidden behind it — no per-footer pixel guessing, works at any footer height. */
.list-table-wrap >>> .v-data-footer {
  position: relative;
  z-index: 4;
  background-color: #fff;
}
.theme--dark .list-table-wrap >>> .v-data-footer {
  background-color: #1e1e1e;
}
</style>
